import { useTheme } from '@emotion/react';
import React from 'react';

import { colors } from '../theme/colors';

interface ProgressBarProps {
  percent: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percent }) => {
  const theme = useTheme();

  return (
    <div
      css={{
        background: colors.neutral90,
        height: '4px',
        width: '100%',
      }}
    >
      <div
        css={{
          background: theme.upsellColor,
          height: '4px',
          width: `${percent}%`,
        }}
      />
    </div>
  );
};
